import React from 'react'
import { Form as AntdForm } from 'antd'
import { FormProps } from 'antd/lib/form'
export type { Store } from 'antd/lib/form/interface'

const Form = (props: FormProps) => {
  return <AntdForm hideRequiredMark layout="vertical" {...props} />
}

export default Form
